
import { computed, defineComponent } from 'vue'

// @new-components
import NewHeader from '@/modules/NewDispatcher/components/NewHeader/index.vue'
import Sidebar from '@/common/components/Sidebar/index.vue'

import { useGlobalStore } from '@/store/globalStore'
import { useRoute } from 'vue-router'

export default defineComponent({
    components: {
        NewHeader,
        Sidebar,
    },
    setup() {
        const store = useGlobalStore()
        const route = useRoute()

        const withoutSectors = computed(() => {
            return !route.path.includes('/new-dispatcher')
        })

        return {
            store,
            //
            withoutSectors,
        }
    },
})
